<template>
  <div>
    <!-- 此处将出现两种不同的头部位  index/others -->
    <div class="index_header" v-if="this.$route.name == 'IndexPc'">
      <div class="index_header_up">
        <img src="~@/assets/images/mainindex/index_header_up_bg-2.png" class="index_header_up_back" alt=""/>
        <div class="container_wrap" style="position: relative">
          <div class="container-btn">
            <!-- <img src="~@/assets/images/mainindex/web-btn.png" alt="" @click="toOldWeb"> -->
          </div>

        </div>
        <div class="index_header_up_tips" v-if="activity.activity_title">
          <p>{{ activity.activity_title }} 还有</p>
          <span>{{ activity.end_day }}</span>
          <p>天</p>
        </div>
      </div>
      <div class="header_direct">
        <div
            class="container_wrap header_direct_bg"
            :class="
            this.$route.name == 'CmsList' || this.$route.name == 'CmsDetail'
              ? 'header_direct_bg_cms'
              : ''
          "
        >
          <div class="header_direct_leftNav">
            <div
                class="header_direct_leftNav_item"
                :class="item.class"
                v-for="(item, index) in navDataArr"
                :key="index"
                @click="headerNavClickFun(index, item)"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="header_direct_rightIcon">
            <div class="headlefticon" v-if="user.id > 0" style="width:300px">
              <div
                  v-rblink="{ name: 'MineIndex' }"
                  style="
                  color: #fff;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  /*margin-left: 150px;*/
                  font-size: 16px;
                "
              >
                {{ user.name }}
              </div>
              <div class="headicon">
                <div class="loginbtn" 
                  v-rblink="{ name: 'MineIndex' }" style="width:100px;margin-right:10px">个人中心</div>
                <div class="loginbtn registerbtn" @click="logout">退出</div>
              </div>
            </div>
 

            <template v-for="(item, index) in headerNavIconArr">
              <div
                  class="header_direct_rightIcon_item"
                  :key="index"
                  v-if="loginshow"
                  @click="action(index)"
              >
                <img :src="item.src" alt=""/>
                <p>{{ item.name }}</p>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="others_header" v-else>
      <div class="header_direct">
        <div
            class="container_wrap header_direct_bg"
            :class="
            this.$route.name == 'CmsList' || this.$route.name == 'CmsDetail'
              ? 'header_direct_bg_cms'
              : ''
          "
        >
          <div style="width: 205px;cursor: pointer" @click="logo"></div>
          <div class="header_direct_leftNav">
            <div
                class="header_direct_leftNav_item"
                :class="item.class"
                v-for="(item, index) in navDataArr"
                :key="index"
                @click="headerNavClickFun(index, item)"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="header_direct_rightIcon">
            <div class="headlefticon" v-if="user.id > 0" style="width:300px">
              <div
                  v-rblink="{ name: 'MineIndex' }"
                  style="
                  color: #fff;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  font-size: 16px;
                "
              >
                {{ user.name }}
              </div>
              <div class="headicon">
                <div class="loginbtn" 
                  v-rblink="{ name: 'MineIndex' }" style="width:100px;margin-right:10px">个人中心</div>
                <div class="loginbtn registerbtn" @click="logout">退出</div>
              </div>
            </div>

            <template v-for="(item, index) in headerNavIconArr2">
              <div
                  class="header_direct_rightIcon_item"
                  :key="index"
                  v-if="loginshow"
                  @click="action(index)"
              >
                <img :src="item.src" alt=""/>
                <p>{{ item.name }}</p>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <router-view></router-view>
    <div class="booter" v-if="this.$route.name != 'Login'">
      <div class="container_wrap booter_content">
        <div class="booter_left">
          <div class="booter_content_title">友情链接</div>
          <div class="booter_left_list">
            <a v-for="item in linkList" :key="item.name" :href="item.url" target="_blank">{{ item.name }}</a>
          </div>
        </div>
        <div class="booter_mid">
          <div class="booter_content_title">关于我们</div>
          <div class="booter_mid_list">
            <p>
              中国蹦床与技巧协会啦啦操分会@2021
            </p>
            <p>江苏省南京市秦淮区永智路6号四号楼A栋3-303</p>
            <p style="cursor: pointer;" v-rblink="{ name: 'Gbook' }">信箱@CCA</p>
            <a href="https://beian.miit.gov.cn/">苏ICP备18049601号-2 法律事务</a>
          </div>
        </div>
        <div class="booter_right">
          <div class="booter_content_title">公众号&APP</div>
          <!--          <div class="booter_right_imgs">-->
          <!--            <img src="~@/assets/images/mainindex/icon-erweima@2x.png" alt=""/>-->
          <!--            <img src="~@/assets/images/mainindex/icon-erweima@2x.png" alt=""/>-->
          <!--          </div>-->
          <!--          <p>更多内容在请扫码关注CCA公众号</p>-->

          <div class="contact-box">
            <div v-for="(item, index) in contactList" class="contact-img">
              <img :src="require('../../assets/images/contact/cca-'+(index+ 1)+'.png')" alt="">
              <!--              <div class="contact-desc">{{ item.desc }}</div>-->
              <!--              <div class="contact-title">{{ item.title }}</div>-->
              <div class="contact-title" v-html="item.title"></div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <el-dialog
        title="提示"
        :visible.sync="centerDialogVisible"
        width="30%"
        center
    >
      <span>正在建设中~</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false"
        >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
        title="公众号二维码"
        :visible.sync="wechatDialogVisible"
        width="300px"
        center
    >
      <div class="tc">
        <!-- <img :src="require('../../assets/images/contact/mini-content.jpg')" alt=""> -->
        <img style="width:100%" :src="require('../../assets/images/contact/cca-2.png')" alt="">
      </div>
      <span slot="footer" class="dialog-footer">
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "IndexLayout",
  data() {
    return {
      centerDialogVisible: false,
      wechatDialogVisible: false,
      loginshow: true,
      user: {
        id: 0,
        name: "",
      },
      activity: {},
      contactList: [
        {title: "啦啦操分会<br />官方网站", desc: "www.ccachina.net"},
        {title: "啦啦操分会<br />微信公众号", desc: "最新最全的啦啦操通知"},
        {title: "啦啦操GO<br />APP", desc: "啦啦操一站式服务APP"},
        // {title: "啦啦操GO<br />微信公众号", desc: "啦啦操一站式服务服务号"},
        // {title: "啦啦之星<br />小程序", desc: "啦啦操线上教学小程序"},
        // {title: "啦啦之星<br />微信公众号", desc: ""},
      ],
      linkList: [
        {name: '国家体育总局', url: 'http://www.sport.gov.cn/'},
        {name: 'CCTV5', url: 'https://tv.cctv.com/cctv5/'},
        {name: '教育部', url: 'http://www.moe.gov.cn/'},
        {name: '中国教育网络电视台', url: 'http://www.centv.cn/'},
        {name: '中国奥委会官网', url: 'http://www.olympic.cn/'},
        {name: '中国教育出版社', url: 'http://www2.zzstep.com/front/index.php'},
      ],
      navDataArr: [
        {
          name: "首页",
          class: "",
          path: "/indexpc",
        },
        // {name: "组织结构", class: "", path: "/organization"},
        {name: "俱乐部七彩星级", class: "", path: "/qcxj-club"},
        {name: "文化纪", class: "", path: "/culturalhistory"},
        {name: "境外交流", class: "", path: "/jingwai"},
        {name: "行业精英", class: "", path: "/tradeelite"},
        {name: "商务合作", class: "", path: "/businesscooperation"},
        {name: "联系我们", class: "", path: "/contactus"},
      ],
      headerNavIconArr: [
        {
          name: "登录",
          src: require("@/assets/images/mainindex/gerenzhongxin.png"),
        },
        {name: "查询", src: require("@/assets/images/mainindex/sousuo.png")},
        {
          name: "微信公众号",
          src: require("@/assets/images/mainindex/weixin.png"),
        },
        {
          name: "啦啦操GO",
          src: require("@/assets/images/mainindex/app-logo.png"),
        },
      ],
      headerNavIconArr2: [
        {
          name: "登录",
          src: require("@/assets/images/mainindex/gerenzhongxin.png"),
        },
        {name: "查询", src: require("@/assets/images/mainindex/sousuo.png")},
      ],
    };
  },
  watch: {
    loginshow(val, oldVal) {
      console.log("loginshow: " + val, oldVal);
    },
    $route(to, from) {
      console.log(to.path);
      this.handleSetRouteClass(to.path)
    },
    immediate: true,
    deep: true,
  },
  mounted() {
  },
  created() {
    // if (localStorage.getItem("_token")) {
    //   this.loginshow = false;
    // }

    this.getUser();
    this.getActivity();

    // 初次进入和刷新页面 判断激活菜单
    this.handleSetRouteClass(this.$route.path)

    console.log('window.location', this.$route.path, window.name)

  },
  methods: {
    linkDownload(url) {
      window.open(url, '_blank') // 新窗口打开外链接
    },
    logo() {
      this.handleSetRouteClass(0)
      this.$router.push({path: "/indexpc"});
    },
    action(index) {
      console.log(index);
      if (index == 0) {
        this.$router.push({path: "/login"});
      } else if (index == 2) {
        // 显示公众号二维码
        this.wechatDialogVisible = true
      }  else if (index == 3) {
        // 显示公众号二维码
        window.location.href = "http://fir.dierqudao.com/859v"
      } else {
        // todo
        this.$router.push({path: "/cha"});
      }
    },
    getUser() {
      let that = this;
      that.$api.post(
          "/api/index/userdata",
          {},
          (r) => {
            that.loginshow = false;
            that.user = r.data;
          },
          (r) => {
            that.loginshow = true;
            // this.$router.replace({path: "/Login"});
            // that.$message.error(r.msg);
          }
      );
    },
    getActivity() {
      let that = this;
      that.$api.post(
          "/api/index/pcIndexActivity",
          {},
          (r) => {
            that.activity = r.data;
          },
          (r) => {
            // that.$message.error(r.msg);
          }
      );
    },
    logout() {
      let that = this;
      this.$confirm("确定退出吗？")
          .then((_) => {
            that.$api.post("/api/index/logout", {}, (r) => {
              localStorage.removeItem("_token");
              that.$router.push({name: "Login"});
              location.reload()
            });
          })
          .catch((_) => {
          });
    },

    toOldWeb() {
      window.location.href = "http://www.ccachina.net/global_index_index2"
    },
    headerNavClickFun(index, val) {
      // if (index == 1 || index == 2 || index == 3 && false) {
      if (false) {
        this.centerDialogVisible = true;
      } else {
        if (val.class != "") {
          return;
        }
        this.$router.push({path: val.path});
      }
    },

    // 设置当前激活的导航显示
    handleSetRouteClass(path) {
      this.navDataArr.map((item) => {
        item.class = "";

        if (item.path == path) {
          item.class = "header_direct_leftNav_item_active";
        }
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.container_wrap {
  width: 1200px;
  margin: 0 auto;
}

.header_direct {
  height: 60px;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 50%;
    display: block;
    background: #3b8de3;
    z-index: -1;
  }

  &::after {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 50%;
    display: block;
    background: #f56057;
    z-index: -1;
  }

  .header_direct_bg {
    height: 60px;
    background: url("~@/assets/images/mainindex/index_header_nav_bg.png");
    background-size: 100% 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .header_direct_leftNav {
      display: flex;
      flex-direction: row;

      .header_direct_leftNav_item {
        //width: 94px;
        padding: 0 10px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        font-size: 18px;
        font-weight: 300;
        color: rgba(255, 255, 255, 0.7);

        &:hover {
          position: relative;
          background: #1d79d9;
          box-shadow: 0px 4px 10px 0px rgba(3, 3, 3, 0.06);
          color: #fff;
          font-weight: 400;
          cursor: pointer;

          &::after {
            content: "";
            position: absolute;
            display: inline-block;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 50px;
            height: 2px;
            background: #f56057;
          }
        }
      }

      .header_direct_leftNav_item_active {
        //width: 120px;
        position: relative;
        background: #1d79d9;
        box-shadow: 0px 4px 10px 0px rgba(3, 3, 3, 0.06);

        &::after {
          content: "";
          position: absolute;
          display: inline-block;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 50px;
          height: 2px;
          background: #f56057;
        }
      }
    }

    .header_direct_rightIcon {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      flex: 0.9;

      .header_direct_rightIcon_item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
          width: 27px;
        }

        &:hover {
          cursor: pointer;

          p {
            font-weight: bold;
          }
        }

        p {
          font-size: 14px;
          font-weight: 300;
          color: #ffffff;
          margin-top: 4px;
        }
      }
    }
  }

  .header_direct_bg_cms {
    position: relative;
    //left: -22px;
  }
}

.index_header {
  height: 196px;
  width: 100%;

  .index_header_up {
    height: 136px;
    text-align: center;
    position: relative;

    .index_header_up_back {
      height: 136px;
      object-fit: cover;
      display: inline-block;
    }

    .container-btn {
      position: absolute;
      right: 0;
      bottom: 20px;
      z-index: 20;
      //width: 200px;

      img {
        width: 180px;
        cursor: pointer;
      }
    }

    .index_header_up_tips {
      height: 40px;
      line-height: 40px;
      width: 400px;
      background: #00b0fd;
      border-radius: 4px;
      position: absolute;
      top: 71px;
      left: 50%;
      transform: translateX(-60%);
      text-align: left;
      padding-left: 9px;
      font-size: 16px;
      font-weight: 300;
      color: #ffffff;
      display: flex;
      flex-direction: row;

      span {
        width: 43px;
        height: 37px;
        line-height: 37px;
        text-align: center;
        background: #ffffff;
        border-radius: 4px;
        font-size: 25px;
        color: #f56057;
        margin: 0 9px;
      }

      p:nth-child(2) {
        font-weight: 300;
        font-size: 25px;
      }
    }
  }

  .header_direct .header_direct_bg .header_direct_leftNav {
    .header_direct_leftNav_item {
      padding: 0 15px;
      &:hover {
        &::after {
          content: "";
          position: absolute;
          display: inline-block;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 70%;
          height: 2px;
          background: #f56057;
        }
      }
    }

    .header_direct_leftNav_item_active {
      &::after {
        content: "";
        position: absolute;
        display: inline-block;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 70%;
        height: 2px;
        background: #f56057;
      }
    }
  }
}

.others_header {
  .header_direct {
    .header_direct_bg {
      background: url("~@/assets/images/mainindex/header_nav_bg.png");
      background-size: 100% 100%;

      .header_direct_leftNav {
        width: 800px;

        box-sizing: border-box;

        .header_direct_leftNav_item {
          //width: 90px;
        }

        .header_direct_leftNav_item_active {
          //width: 90px;
          position: relative;
          background: #1d79d9;
          box-shadow: 0px 4px 10px 0px rgba(3, 3, 3, 0.06);

          &::after {
            content: "";
            position: absolute;
            display: inline-block;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 70%;
            height: 2px;
            background: #f56057;
          }
        }
      }

      .header_direct_rightIcon {
        flex: 1;
      }
    }
  }
}

.booter {
  min-height: 257px;
  background: #2d3237;
  overflow: hidden;

  .booter_content {
    display: flex;
    flex-direction: row;
    margin-top: 31px;

    .contact-box {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      color: #fff;
      width: 100%;

      .contact-title {
        font-size: 12px;
        font-weight: 500;
      }

      .contact-desc {
        font-size: 12px;
      }

      .contact-img {
        width: 24%;
        text-align: center;
        margin-bottom: 5px;

        &:nth-child(3n) {
          margin-right: 22%;
        }
      }

      img {
        width: 100%;
      }
    }

    p {
      font-size: 14px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 300;
      color: rgba(255, 255, 255, 0.7);
      line-height: 15px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .booter_content_title {
      height: 22px;
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      line-height: 22px;
      text-align: left;
      margin-bottom: 21px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

    }

    .booter_left {
      width: 306px;

      .booter_left_list {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        height: 80px;

        a {
          flex: 50%;
          height: 20px;
          font-size: 14px;
          //font-weight: 300;
          color: rgba(255, 255, 255, 0.7);
          line-height: 20px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          &:hover {
            transition: all 0.2s;
            color: #fff;
          }
        }
      }
    }

    .booter_mid {
      width: 518px;
      margin-right: 48px;

      .booter_mid_list {
        p {
          font-size: 14px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          color: rgba(255, 255, 255, 0.7);
          line-height: 20px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

        }

        a {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.7);
          //line-height: 20px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          display: block;
          margin-top: 5px;

          &:hover {
            transition: all 0.2s;
            color: #fff;
          }
        }
      }
    }

    .booter_right {
      flex: 1;

      .booter_right_imgs {
        display: flex;
        flex-direction: row;
        margin-bottom: 23px;

        img {
          width: 72px;
          height: 72px;

          &:last-child {
            margin-left: 18px;
          }
        }
      }
    }
  }
}

.headlefticon {
  display: flex;
  flex-direction: row;
  width: 138px;
  height: 36px;
  margin-left: 80px;
  cursor: pointer;
  //margin-left: 0 !important;

  .headicon {
    display: flex;
    flex-direction: row;
    align-items: center;

    &:last-child {
      margin-left: 10px;
    }

    .loginbtn {
      background: #4e81df;
      text-align: center;
      height: 36px;
      width: 64px;
      line-height: 32px;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.3);
      border-radius: 19px;
      border: 2px solid #ffffff;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      box-sizing: border-box;

      &:hover {
        cursor: pointer;
        opacity: 0.8;
        font-weight: bold;
      }
    }

    .registerbtn {
      background: #d22c46;
    }
  }
}
</style>



// WEBPACK FOOTER //
// IndexLayout.vue?09e29178